var render = function render(){var _vm=this,_c=_vm._self._c;return _c('onoff-toggle',{attrs:{"onColor":"#29BCFF","offColor":"#CCCCCC","shadow":true,"width":"37","height":"22","theme":"ios"},model:{value:(_vm.computedInputData),callback:function ($$v) {_vm.computedInputData=$$v},expression:"computedInputData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }